import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CommerceCard } from 'Components/molecules/CommerceCard';
import { LeasingCarDealsCard } from 'Components/molecules/LeasingCarDealsCard';
import { NewCarDealsCard } from 'Components/molecules/NewCarDealsCard';
import { StockDealsCard } from 'Components/molecules/StockDealsCard';
import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

const DealsBlock = ({
  content,
  context: { cssPrefix },
  disclaimer,
  extraClassNames,
  isScrollable,
  title,
  type,
}) => {
  // Returns null if `content` is not an array or is an empty array.
  if (!Array.isArray(content) || !content.length) {
    return null;
  }

  const getDealsBlockItems = () => {
    const componentMap = {
      commerce: CommerceCard,
      usedDealsBlock: StockDealsCard,
      newCarDealsBlock: NewCarDealsCard,
      leasingCarDealsBlock: LeasingCarDealsCard,
    };

    const Component = componentMap[type];

    if (!Component) {
      return null;
    }

    const isMobileOnly = (index) => {
      if (type !== 'usedDealsBlock') return false;
      const numToTrim = content.length % 3;
      return (content.length - index <= numToTrim) && content.length > 3;
    };

    return content.map((item, index) => (
      <Component
        {...item}
        key={index}
        extraClassNames={{
          ...item.extraClassNames,
          [`${cssPrefix}__deals-block--item`]: true,
          [`${cssPrefix}__deals-block--item--mobile-only`]: isMobileOnly(index),
        }}
      />
    ));
  };

  return ((
    <div className={classNames({
      [`${cssPrefix}__deals-block`]: true,
      [`${cssPrefix}__deals-block--${type}`]: true,
      '-is-scrollable': isScrollable,
      ...extraClassNames,
    })}
    >
      <div className={`${cssPrefix}__deals-block--header`}>
        <p className={`${cssPrefix}__deals-block--title`}>{title}</p>
      </div>
      <div className={`${cssPrefix}__deals-block--items`}>
        {getDealsBlockItems()}
      </div>
      {disclaimer && (
        <div className={`${cssPrefix}__deals-block--disclaimer`}>
          {disclaimer}
        </div>
      )}
    </div>
  ));
};

DealsBlock.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape()),
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  disclaimer: PropTypes.oneOfType([
    PropTypes.shape({
      html: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  extraClassNames: PropTypes.shape(),
  isScrollable: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
};

DealsBlock.defaultProps = {
  content: [],
  context: {
    cssPrefix: '',
  },
  disclaimer: '',
  extraClassNames: {},
  isScrollable: true,
  title: '',
  type: 'commerce',
};

export default withPolaris(DealsBlock);
